import { useTranslation } from "react-i18next";
import { List, Plus, CheckCheck, BarChart3, Bell } from "lucide-react";

const PILL = "flex items-center gap-1.5 rounded-2xl px-3 py-2 text-[11px] sm:px-4 sm:py-2.5 sm:text-sm font-black transition";
const ACTIVE = "ring-2 ring-primary ring-offset-2 ring-offset-background scale-[1.02]";

// شريط ثابت: زرّ "إضافة فاتورة" أقصى اليسار — يُبرَز التبويب النشط عبر active.
export const BillsToolbar = ({ onNew, onList, onApprovals, onReports, onAlerts,
                               alerts, approvals, active = "list" }) => {
  const { t } = useTranslation();
  const is = (k) => (active === k ? ACTIVE : "");
  return (
    <div className="flex flex-wrap items-center justify-between gap-3" data-testid="bills-toolbar">
      <button className={`${PILL} bg-primary text-primary-foreground hover:bg-primary/90 shadow-md ${is("add")}`}
              onClick={onNew} data-testid="bill-add-btn">
        <Plus className="h-4 w-4" /> {t("acct.bills.tabs.add")}
      </button>
      <div className="flex flex-wrap items-center gap-3">
        <button className={`${PILL} bg-foreground text-background border-2 border-foreground shadow-md ${is("list")}`}
                onClick={onList} data-testid="bills-list-btn">
          <List className="h-4 w-4" /> {t("acct.bills.tabs.list")}
        </button>
        <button className={`${PILL} bg-emerald-500/10 text-emerald-600 hover:bg-emerald-500/20 border border-emerald-500/30 ${is("approvals")}`}
                onClick={onApprovals} data-testid="bills-approvals-btn">
          <CheckCheck className="h-4 w-4" /> {t("acct.bills.tabs.approvals")}
          {approvals ? <span className="rounded-full bg-emerald-500 px-1.5 text-[10px] font-black text-white">{approvals}</span> : null}
        </button>
        <button className={`${PILL} bg-violet-500/10 text-violet-600 hover:bg-violet-500/20 border border-violet-500/30 ${is("reports")}`}
                onClick={onReports} data-testid="bills-reports-btn">
          <BarChart3 className="h-4 w-4" /> {t("acct.bills.tabs.reports")}
        </button>
        <button className={`${PILL} bg-primary/10 text-primary hover:bg-primary/20 border border-primary/30 ${is("alerts")}`}
                onClick={onAlerts} data-testid="bills-alerts-btn">
          <Bell className="h-4 w-4" /> {t("acct.bills.tabs.alerts")}
          {alerts ? <span className="rounded-full bg-rose-500 px-1.5 text-[10px] font-black text-white">{alerts}</span> : null}
        </button>
      </div>
    </div>
  );
};
